import { ValidateTokenTranslation } from '../../types/validateToken.types';

export const validateToken: ValidateTokenTranslation = {
  title: 'Validando token...',
};

export default validateToken;
